<template lang="pug">
v-dialog(scrollable lazy v-model='dialog' :max-width='1000' :fullscreen='isFullscreen')
  v-card(@keyup.esc='close')
    //- 對話框標題列
    v-toolbar(color='primary' dark style={zIndex: 10000})
      v-btn(icon dark @click='close' :disabled='isLoading'): v-icon close
      v-toolbar-title 晉級表單
      v-spacer
      v-toolbar-items: v-btn(flat @click='advance' v-if='forms' :disabled='selected.length <= 0' :loading='isLoading')
        | 晉級 {{ selected.length }} 個表單

    //- 錯誤提示訊息
    v-alert(type='error' :value='true' v-if='forms === false' icon='warning') {{ $t('errorWhileLoading') }} {{ error }}
    v-alert(type='error' :value='true' v-else-if='isSaveFailed && error' icon='warning') {{ $t('failedToSave') }} {{ error.response }}

    v-card-title
      .title {{ (formGroupId !== -1) ? convertGroupText(formGroupId) : `ALL` }}
      v-divider.mx-2(vertical)
      v-slide-y-reverse-transition(hide-on-leave)
        span(v-if='selected.length > 0') 已選取了 {{ selected.length }} 個表單
      v-spacer
      v-text-field.search-field(v-model.trim='search' prepend-icon='search' label='搜尋' clearable hide-details)
        v-menu(bottom right offset-y slot='append-outer')
          v-icon(small slot='activator' :color='filter.status.some(v => !v.value) ? `primary` : ``') fas fa-filter
          v-list(subheader)
            v-subheader 依繳費狀態篩選
            v-list-tile(@click='filter.status[index].value = !filter.status[index].value' v-for='(i, index) in filter.status' :key='index')
              v-list-tile-action: v-icon(:color='i.value ? `primary` : ``') {{ i.value ? `fa fa-check-square` : `far fa-square` }}
              v-list-tile-title {{ convertFormStatusObject(i.key).name }}

    //- 表單
    v-data-table(
      :headers='headers'
      :items='filteredForms'
      :pagination.sync='pagination'
      :rows-per-page-items='[10, 25, 50, { "text": "$vuetify.dataIterator.rowsPerPageAll", "value": -1 } ]'
      item-key='id'
      v-if='forms'
      style='-webkit-overflow-scrolling: touch'
    )
      template(slot='items' slot-scope='props')
        tr(:class='{ active: selected.some(_ => _ === props.item.id) }')
          td: v-checkbox(v-model='selected' :value='props.item.id' color='primary' hide-details :key='props.item.id' :disabled='!props.item.isAdvanceable')
          td.text-no-wrap {{ convertGroupText(props.item.group) }}
          td.text-truncate(style={ maxWidth: `200px` } :title='`${props.item.name} / ${props.item.school || "社會組"}`')
            | {{ props.item.name }}
            span.grey--text.mx-1 -
            .span(v-if='props.item.school') {{ props.item.school }}
            em(v-else) 社會組
          td.text-truncate(style={ maxWidth: `200px` } :title='props.item.song') {{ props.item.song }}
          td {{ props.item.timestamp | time }}
          td {{ props.item.email }}
          td.phone
            PhoneNumberText(:value='props.item.phone')
          td(:class='convertFormStatusObject(props.item.status).class') {{ convertFormStatusObject(props.item.status).name }}

    Loader(:show='!forms')
</template>

<script>
import { formStatus } from '@/mixins/formStatus'
import Loader from '@/components/Loader.vue'
import apis from '@/assets/js/apis'
import { filterForms } from '@/modules/filterForms'
import PhoneNumberText from '@/components/PhoneNumberText.vue'

export default {
  name: 'AdvanceForm',
  props: {
    forms: {
      type: Array,
      default: () => [],
    },
    formGroupId: {
      type: Number,
      default: -1,
    },
    period: {
      type: Number,
      default: null,
    },
  },
  data () {
    return {
      headers: [
        { text: ' ', value: 'checkBox', sortable: false },
        { text: '組別', value: 'group' },
        { text: '報名人', value: 'name' },
        { text: '歌曲', value: 'song' },
        { text: '學校', value: 'school', class: 'hidden' },
        { text: '報名時間', value: 'timestamp' },
        { text: 'Email', value: 'email' },
        { text: '電話', value: 'phone' },
        { text: '狀態', value: 'status' },
      ],
      pagination: {
        sortBy: 'timestamp',
        descending: true,
      },
      search: '',
      filter: {
        status: [{ key: 1, value: true }, { key: 2, value: true }],
      },
      selected: [],
    }
  },
  methods: {
    init () {
      this.clearError()
      this.dialog = true
      this.selected = []
      this.filter = {
        status: [{ key: 1, value: true }, { key: 2, value: true }],
      }
      this.search = ''
    },
    advance () {
      if (!confirm(`是否確認晉升所選取的 ${this.selected.length} 個表單？`)) return

      this.clearError()
      this.isSaving = true
      const body = { formId: this.selected, period: this.period }

      apis.form.advance(body, this.token)
        .then(() => {
          this.$emit('success', 'advanceMultiple')
          this.close()
          this.isSaving = false
          this.error = null
        })
        .catch((e) => {
          const status = e.response.status
          if (status >= 400 && status < 500) { alert(`操作失敗！ ${status}`) } else { alert('操作失敗！ 請確認網路連線是否正常，若仍出現錯誤請聯繫客服人員') }
          this.isSaving = false
        })
    },
  },
  computed: {
    isLoading () {
      return (this.isSaving || !this.forms) && !this.error
    },
    filteredForms () {
      return filterForms(this.forms, {
        search: this.search,
        status: this.filter.status,
      })
    },
  },
  components: {
    Loader,
    PhoneNumberText,
  },
  mixins: [formStatus],
}
</script>

<style scoped lang="sass">
.search-field
  max-width: 20rem

.phone
  span.fragment
    &:not(:last-child)::after
      content: '-'
      color: grey
      letter-spacing: 0

tr.active
  background: rgba(0,0,0,.1)
</style>
